module.exports = __webpack_public_path__ + "img/hpb.44d324f8.svg";